import React from 'react'
import { FormSection } from 'rds'

const CheckoutFormSection = ({ title, children }) => {
    return (
        <FormSection
            title={title}
            className='rds-full-block rds-m_bottom__sm rds-overflow_visible'
        >
            {children}
        </FormSection>
    )
}

export default CheckoutFormSection
